var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.323L14.1464 11.1765C14.3417 10.9813 14.6583 10.9813 14.8536 11.1765C15.0488 11.3718 15.0488 11.6884 14.8536 11.8837L11.8536 14.8837C11.6583 15.0789 11.3417 15.0789 11.1464 14.8837L8.14645 11.8837C7.95118 11.6884 7.95118 11.3718 8.14645 11.1765C8.34171 10.9813 8.65829 10.9813 8.85355 11.1765L11 13.323L11 5.71191C11 5.43577 11.2239 5.21191 11.5 5.21191C11.7761 5.21191 12 5.43577 12 5.71191L12 13.323ZM5.5 13.0301C5.77614 13.0301 6 13.254 6 13.5301V17.3483C6 17.3603 6.00479 17.3719 6.01331 17.3804C6.02184 17.3889 6.0334 17.3937 6.04545 17.3937H16.9545C16.9666 17.3937 16.9782 17.3889 16.9867 17.3804C16.9952 17.3719 17 17.3603 17 17.3483V13.5301C17 13.254 17.2239 13.0301 17.5 13.0301C17.7761 13.0301 18 13.254 18 13.5301V17.3483C18 17.6255 17.8899 17.8915 17.6938 18.0875C17.4977 18.2836 17.2318 18.3937 16.9545 18.3937H6.04545C5.76818 18.3937 5.50227 18.2836 5.30621 18.0875C5.11015 17.8915 5 17.6256 5 17.3483V13.5301C5 13.254 5.22386 13.0301 5.5 13.0301Z",
    fill: "#4D4E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.09e54a571be4fec1a6641c3acc489fed.svg";
export { ForwardRef as ReactComponent };